import React from 'react';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from 'prop-types';
import { FormHelperText, Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useCommonStyles } from '../Styles';
import { EnumValues } from '../EnumValue';

const SIZE_HEIGHTS = { small: '24px', medium: '32px', large: '40px' };

export function ToggleButtonGroupWrapped(props) {
  const {
    onChange,
    enumMeta,
    enumMetaArray,
    defaultValue,
    disabled,
    size,
    exclusive,
    idToolTipMode,
    withNull,
    suppressIds,
  } = props;
  const [value, setValue] = React.useState(defaultValue);
  let enumSeq = enumMetaArray || Object.entries(enumMeta).map(k => ({
    name: k[0],
    description: k[1].description,
  }));

  if (suppressIds) {
    enumSeq = enumSeq.filter(enumEntry => !suppressIds.includes(enumEntry.name));
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      size={size}
      onChange={(e, newValue) => {
        onChange && onChange(newValue);
        setValue(newValue);
      }}
    >
      {withNull && (
        <ToggleButton
          disabled={disabled}
          value={null}
          size={size}
          style={{ height: SIZE_HEIGHTS[size] }}
        >
          ∅
        </ToggleButton>
      )}

      {
        enumSeq.map(enumEntry => (
          idToolTipMode ? (

            <Tooltip title={enumEntry.description}>
              <ToggleButton
                disabled={disabled}
                value={enumEntry.name}
                size={size}
                style={{ height: SIZE_HEIGHTS[size] }}
                selected={exclusive ? (enumEntry.name === value) : value.includes(enumEntry.name)}
              >
                {enumEntry.name}
              </ToggleButton>
            </Tooltip>

          ) : (
            <ToggleButton
              disabled={disabled}
              value={enumEntry.name}
              size={size}
              style={{ height: SIZE_HEIGHTS[size] }}
            >
              {enumEntry.description}
            </ToggleButton>
          )
        ))
      }
    </ToggleButtonGroup>
  );
}

function InnerTabFilterToggleButtonGroup(props) {
  const classes = useCommonStyles();
  const { 
    onChange,
    enumType,
    defaultValue,
    label,
    helperText,
    gridItemProps,
    exclusive,
    idToolTipMode,
    withNull,
    suppressIds,
  } = props;

  return (
    <Grid {...gridItemProps} item>
      <FormControl className={classes.formControlToggleButtonGroup}>
        <InputLabel htmlFor="accountType-helper">{label}</InputLabel>
        <EnumValues
          enumType={enumType}
          render={(enumMeta, enumMetaArray) => (
            <ToggleButtonGroupWrapped
              withNull={withNull}
              enumMeta={enumMeta}
              enumMetaArray={enumMetaArray}
              defaultValue={defaultValue}
              onChange={onChange}
              exclusive={exclusive}
              idToolTipMode={idToolTipMode}
              suppressIds={suppressIds}
            />
          )}
        />

        {helperText && (
          <FormHelperText>{helperText}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
}

InnerTabFilterToggleButtonGroup.propTypes = {
  defaultValue: PropTypes.any.isRequired,
  enumType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  gridItemProps: PropTypes.object,
  exclusive: PropTypes.bool,
  idToolTipMode: PropTypes.bool,
  withNull: PropTypes.bool,
};

InnerTabFilterToggleButtonGroup.defaultProps = {
  helperText: null,
  onChange: null,
  gridItemProps: {},
  exclusive: true,
  idToolTipMode: false,
  withNull: false,
};

export default InnerTabFilterToggleButtonGroup;
